import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from "react-tooltip";

const listCertified = [
  {
    label: 'Lulus 153 poin inspeksi',
    tooltip: 'Telah diinspeksi sebanyak 153 poin secara menyeluruh, mulai dari interior, eksterior, mesin, chassis, suspensi hingga roda.'
  },
  {
    label: 'Garansi 100 hari',
    tooltip: 'Garansi mesin berlaku 100 hari terhitung sejak serah terima sebagai jaminan kendaraan sudah lulus inspeksi dan layak jalan.'
  },
  {
    label: 'Inspeksi Bengkel Resmi',
    tooltip: 'Inspeksi dilakukan oleh mekanik resmi di bengkel resmi.'
  },
  {
    label: 'Odometer Asli',
    tooltip: 'Mobil Capella Certified memiliki odometer asli dan terjamin tidak pernah diputar balik.'
  },
  {
    label: 'Bebas Kecelakaan',
    tooltip: 'Bebas kecelakaan yang biasanya mengakibatkan kerusakan fatal pada rangka utama mobil.'
  },
  {
    label: 'Bebas Terendam Banjir',
    tooltip: 'Tidak pernah terendam banjir secara major sampai interior, kabin maupun ruang mesin mobil.'
  },
  {
    label: 'Pemakaian < 3 Tahun',
    tooltip: 'Mobil yang lulus uji Capella Certified adalah mobil yang memiliki usia pemakaian di bawah 3 tahun.'
  },
  {
    label: 'Odometer < 60.000km',
    tooltip: 'Jarak tempuh yang singkat dengan odometer maksimal 60.000 km.'
  },
  {
    label: 'Goresan < Diameter 3cm',
    tooltip: 'Bebas dari goresan dan lecet yang dapat diukur dengan luas diameter 3 cm.'
  },
  {
    label: 'Spooring & Balancing',
    tooltip: 'Dilakukan spooring dan balancing untuk memastikan keamanan dan kenyamanan dalam berkendara.'
  }
]

const overridePosition = ({ left, top }) => {
  return {
    left: window.innerWidth < 768 ? 0 : left,
    top
  }
}

const TableCertified = () => {
  return (
    <div className="cmd-table">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col" className="cmd-table-check--wrapper">
                <div className="text--center">
                  Capella Certified
                </div>
              </th>
              <th scope="col">
                <div className="text--center">
                  Mobil Bekas Lainnya
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            { listCertified.map((list, index) => (
              <tr key={`list-${index}`}>
                <td className="cmd-table-title--wrapper">
                  <div className="cmd-table-title">
                    <span>{list.label}</span>
                    <span className="cmd-table-tooltip-icon" data-tip={list.tooltip}><FontAwesomeIcon icon={faInfoCircle} /></span>
                  </div>
                  <ReactTooltip overridePosition={overridePosition} />
                </td>
                <td className="cmd-table-check--wrapper cmd-table-icon-content">
                  <div className="text--center">
                    <FontAwesomeIcon icon={faCheckCircle} />
                  </div>
                </td>
                <td className="list-times cmd-table-icon-content">
                  <div className="text--center">
                    <span className="cmd-table-icon-times"><FontAwesomeIcon icon={faTimesCircle} /></span>
                  </div>
                </td>
              </tr>
            )) }
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TableCertified